<template>
    <div class="team-standings">
        <!-- the team's programme, as on the home page: live and next matches on top, the results below -->
        <section v-if="matches.length" class="cl-section">
            <section-heading title="Πρόγραμμα" icon="mdi-calendar-outline" />
            <match-center :matches="matches" :all-to="null" all-label="Όλοι οι αγώνες" @show-all="$emit('show-all')" />
        </section>
        <section class="cl-section">
            <section-heading :title="type === 'cup' || type === 'playoffs' ? 'Πλέι οφ' : 'Βαθμολογία'" icon="mdi-podium" />
            <league-standings v-if="type !== 'cup' && type !== 'playoffs'" :ranking="ranking || []" />
            <!-- the bracket made in the CMS; the playoffs of a league without one: the picture of its standings -->
            <template v-else>
                <bracket-board v-if="bracketLoaded" :bracket="bracket" @match="openMatch" />
            </template>
        </section>
    </div>
</template>

<script>
    import BracketBoard from '@/components/BracketBoard'
    import bracketService from '@/services/bracket'
    import LeagueStandings from '@/components/LeagueStandings'
    import MatchCenter from '@/components/MatchCenter'
    import SectionHeading from '@/components/SectionHeading'

    export default {
        components: { BracketBoard, LeagueStandings, MatchCenter, SectionHeading },
        props: {
            type: {
                type: String,
                default: null
            },
            showFilters: {
                type: Boolean,
                default: true
            },
            ranking: {
                type: Array,
                default: null
            },
            matches: {
                type: Array,
                default: () => []
            },
            // {seasonId, leagueId} or {seasonId, cup, cupLeagueId}; null: no bracket
            bracketScope: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                bracket: null,
                bracketLoaded: false,
                bracketRequest: null
            }
        },
        watch: {
            bracketScope: {
                handler(scope, previous) {
                    // a new object with the same scope (the team reloaded): nothing to fetch again
                    if (JSON.stringify(scope) !== JSON.stringify(previous)) {
                        this.fetchBracket()
                    }
                },
                immediate: true
            }
        },
        methods: {
            goToTeam(team) {
                this.$router.push({ name: 'Team', params: { id: team.id } })
            },
            fetchBracket() {
                this.bracket = null
                this.bracketLoaded = false
                const scope = this.bracketScope
                const requestKey = JSON.stringify(scope)
                this.bracketRequest = requestKey
                if (!scope) {
                    this.bracketLoaded = true
                    return
                }
                bracketService.getBracket(scope).then(resp => {
                    // only the answer of the latest choice
                    if (this.bracketRequest === requestKey) {
                        this.bracket = resp.data || null
                    }
                }).catch(() => {}).finally(() => {
                    if (this.bracketRequest === requestKey) {
                        this.bracketLoaded = true
                    }
                })
            },
            openMatch(matchId) {
                this.$router.push(`/Match/${matchId}`)
            }
        }
    }
</script>
